/* eslint-disable local-rules/no-direct-import */
/* eslint-disable react/prop-types */
/* eslint-disable camelcase */
import { useEffect, useRef, useState } from 'react';

import { useDispatch, useSelector } from 'react-redux';

import { closePosition } from 'actions/trade';
import { SOURCE_FOR_MIXPANEL_EVENTS } from 'constants/enums';
import {
  // getROE,
  getUnrealisedPnl,
  getIrsUnPnl,
  getSelectedAssetForPosition,
  // getIrsRoe,
  // calculateImpactPrice,
} from 'helpers/formulas';
import { pathOr } from 'helpers/ramda';
import { addLogsToSentry } from 'helpers/sentry';
import {
  convertExponentialToDecimal,
  cropAfterDecimals,
  isMobileOrTablet,
} from 'helpers/utils';
import subscribe from 'HOC/subscribe';
import useOpenPositionExitPrice from 'hooks/componentHooks/useOpenPositionExitPrice';
import { allPositionsIncludingTrackersHoldings } from 'selectors/holdingsSelectors';
import { userSelector } from 'selectors/otherSelectors';
import {
  // markPriceSelectorById,
  spotPriceState,
} from 'selectors/priceSelectors';
import { selectedProductSelector } from 'selectors/tradeSelectors';

export function createOrderFromOpenPosition(openPosition) {
  const side = openPosition.size > 0 ? 'sell' : 'buy';

  const { product } = openPosition;

  const size = Math.abs(openPosition.size);
  const {
    id,
    contract_type,
    notional_type,
    contract_value,
    // underlying_asset: { precision },
    // settling_asset: { symbol: settlingSymbol },
  } = product;

  const {
    precision,
    symbol: settlingSymbol,
    minimum_precision,
  } = getSelectedAssetForPosition(product);

  const orderProps = {
    contract_type,
    contract_value,
    notional_type,
    settlingSymbol,
    minimum_precision,
    size,
  };

  return {
    product_id: id,
    size,
    side,
    order_type: 'market_order',
    cancel_orders_accepted: 'true',
    precision,
    orderProps,
  };
}

const OpenPositionLine = props => {
  const { widgetRef, onClose, isChartReady, currentActiveTab } = props;

  const [showPosition, setShowPosition] = useState(false);
  const previousTab = useRef('');
  const allOpenPositions = useSelector(allPositionsIncludingTrackersHoldings);
  const selectedProduct = useSelector(selectedProductSelector);
  const openPosition = allOpenPositions.find(
    position => position.product.id === selectedProduct.id
  );
  const cancellations = useSelector(state => state.cancellations.openPositions);
  const user = useSelector(userSelector);
  const isCancelling = cancellations[pathOr(0, ['product', 'id'], openPosition)];
  const dispatch = useDispatch();
  const positionLine = useRef(null);
  const exitPrice = useOpenPositionExitPrice(openPosition, openPosition?.product);

  // let markPrice;
  // let roe;
  let unrealised_pnl;
  if (openPosition) {
    // markPrice = markPriceState();
    const spotPrice = spotPriceState();

    const position = {
      realized_funding: openPosition.realized_funding,
      realized_pnl: openPosition.realized_pnl,
      size: openPosition.size,
      margin: openPosition.margin,
    };

    // const exitPrice = isOptions(openPosition.product.contract_type)
    //   ? optionsExitPrice
    //   : markPrice;

    unrealised_pnl =
      openPosition.product?.contract_type === 'interest_rate_swaps'
        ? getIrsUnPnl(
            openPosition.product,
            spotPrice,
            exitPrice,
            position,
            openPosition.entry_price,
            openPosition.created_at
          )
        : getUnrealisedPnl(
            openPosition.product?.notional_type,
            openPosition.product?.contract_value,
            openPosition.entry_price,
            exitPrice,
            openPosition.size
          );
  }

  // console.log("DEBUG: lastTradedPrice OpenPositionLine", lastTradedPrice)

  // if (openPosition) {
  //   if (
  //     (openPosition.product.contract_type === 'perpetual_futures' ||
  //       openPosition.product.contract_type === 'interest_rate_swaps') &&
  //     openPosition.margin <= 0
  //   ) {
  //     roe = '-';
  //   } else {

  //     roe =
  //       openPosition.product.contract_type === 'interest_rate_swaps'
  //         ? getIrsRoe(position, unrealised_pnl)
  //         : getROE(
  //             unrealised_pnl,
  //             openPosition.margin,
  //             openPosition.product,
  //             openPosition.entry_price,
  //             openPosition.size
  //           );

  //     roe = Number(roe).toFixed(
  //       openPosition.product.quoting_asset.minimum_precision
  //     );
  //   }
  // }

  // when roe changes updating the line
  useEffect(() => {
    // eslint-disable-next-line no-underscore-dangle
    if (positionLine.current != null && positionLine.current._line) {
      positionLine.current.setText(
        `PnL : ${cropAfterDecimals(
          convertExponentialToDecimal(unrealised_pnl),
          openPosition?.product?.settling_asset?.minimum_precision
        )} ${openPosition?.product?.settling_asset?.symbol}`
      );
      positionLine.current.setCloseEnabled(!isCancelling);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [unrealised_pnl, isCancelling]);

  useEffect(() => {
    // eslint-disable-next-line no-underscore-dangle
    if (positionLine.current != null && positionLine.current._line) {
      positionLine.current.setQuantity(openPosition.size);
      positionLine.current.setPrice(parseFloat(openPosition.entry_price));
    }
  }, [openPosition]);

  const orderInfo = JSON.stringify(openPosition);

  useEffect(() => {
    // console.log('Show Position :: ', showPosition, openPosition);
    const dispatchClosePosition = position => {
      const order = createOrderFromOpenPosition(position);
      dispatch(
        closePosition(order, {
          totalPositions: openPosition.size,
          chart: true,
          orderProps: order.orderProps,
          precision: order.precision,
          source: SOURCE_FOR_MIXPANEL_EVENTS.CHART,
        })
      );
    };

    const onCloseClick = () => {
      setTimeout(() => {
        onClose(dispatchClosePosition, openPosition);
      }, 250);
    };

    // eslint-disable-next-line no-underscore-dangle
    if (positionLine.current != null && positionLine.current._line) {
      positionLine.current.remove();
    }

    const timeoutId = setTimeout(() => {
      if (isChartReady && openPosition && showPosition) {
        // console.log('Position Rendering');
        try {
          positionLine.current = widgetRef?.current
            ?.activeChart()
            ?.createPositionLine()
            ?.onClose(() => onCloseClick())
            ?.setText(
              `PnL : ${cropAfterDecimals(
                convertExponentialToDecimal(unrealised_pnl),
                openPosition?.product?.settling_asset?.minimum_precision
              )} ${openPosition?.product?.settling_asset?.symbol}`
            )
            .setBodyBorderColor('#42b6f6')
            .setBodyFont('12px Verdana')
            .setQuantityFont('12px Verdana')
            .setLineColor('#42b6f6')
            .setBodyBackgroundColor('#1f4055')
            .setQuantityBackgroundColor('#42b6f6')
            .setQuantityBorderColor('#42b6f6')
            .setBodyTextColor('#ffffff')
            .setCloseButtonBorderColor('#42b6f6')
            .setCloseButtonBackgroundColor('#1f4055')
            .setCloseButtonIconColor('#e55541')
            .setLineLength(95)
            .setQuantity(openPosition.size)
            .setPrice(parseFloat(openPosition.entry_price));

          if (isMobileOrTablet()) {
            positionLine.current
              .setBodyFont('10px Verdana')
              .setQuantityFont('10px Verdana');
          }
        } catch (e) {
          console.error('DEBUG: Error creating position line', e);
          addLogsToSentry(user, `Error creating position line ${e}`);
        }
      }
    }, 1000);

    return () => {
      // eslint-disable-next-line no-underscore-dangle
      if (positionLine.current != null && positionLine.current._line) {
        positionLine.current.remove();
      }
      positionLine.current = null;
      clearTimeout(timeoutId);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [orderInfo, isChartReady, showPosition]);

  useEffect(() => {
    if (previousTab?.current !== currentActiveTab) {
      setShowPosition(false);
      setTimeout(() => {
        setShowPosition(true);
      }, 1000);
    }
  }, [currentActiveTab]);

  return null;
};

export default subscribe(OpenPositionLine);
